import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { usePortfolio } from '../../../Context/PortfolioContext'; // Adjust the path as needed

ChartJS.register(ArcElement, Tooltip, Legend);

const generateHSLColors = (length) => {
  const colors = [];
  const colorStep = 360 / length; // Divide the color wheel into 'length' parts

  for (let i = 0; i < length; i++) {
    const hue = i * colorStep;
    colors.push(`hsl(${hue}, 100%, 50%)`); // 100% saturation, 50% lightness
  }

  return colors;
};

const OptimizationResultsPieChart = () => {
  const { portfolioData } = usePortfolio();
  const { optimizedWeights } = portfolioData.optimizationResults;
  const { selectedAssets } = portfolioData;

  const labels = selectedAssets.map(asset => asset.name || "Unknown Asset");
  const backgroundColors = generateHSLColors(selectedAssets.length);

  const data = {
    labels,
    datasets: [
      {
        data: optimizedWeights || [],
        backgroundColor: backgroundColors,
        hoverBackgroundColor: backgroundColors,
        borderWidth: 2, // Adjust line thickness here
      }
    ]
  };

  const options = {
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
            family: "'Roboto', sans-serif", // Ensure this font is loaded in your project
          }
        }
      }
    }
  };

  return <Pie data={data} options={options} />;
};

export default OptimizationResultsPieChart;
